<template>
  <div>
    <CandidateLogMessagesBlock
      v-for="message in filteredMessages"
      :key="`${message.type}-${message.id}`"
      :vacancy="vacancy"
      :message="message"
      :candidate="candidate"
      :show-review="showReview"
      @show-interview="$emit('show-interview', $event)"
      @change-active-tab="$emit('change-active-tab', $event)"
    />
  </div>
</template>

<script>
import {
  computed, toRefs,
} from '@vue/composition-api';
import { candidateLogType } from '@/enums';
import CandidateLogMessagesBlock from './CandidateLogMessagesBlock.vue';

export default {
  name: 'CandidateLogMessages',
  components: { CandidateLogMessagesBlock },
  props: {
    vacancy: {
      type: Object,
      required: true,
    },
    messages: {
      type: Array,
      required: true,
    },
    candidate: {
      type: Object,
      required: true,
    },
    showReview: {
      type: Boolean,
      required: true,
    },
  },
  setup(props) {
    const { candidate, messages } = toRefs(props);
    const transcriptions = computed(() => candidate.value?.interview?.timestamps?.some(i => i.transcription !== null));

    const candidateCreatedAt = computed(() => candidate.value?.createdAt);
    const isCandidateAdditionalFields = computed(() => !!candidate.value.additionalFields);

    const messagesWithAddFields = computed(() => (isCandidateAdditionalFields.value
      ? [
        {
          createdAt: candidateCreatedAt.value,
          eventType: 'candidate_additional_fields',
        },
        ...messages.value,
      ] : messages.value));

    const filteredMessages = computed(() => (!transcriptions.value ? messagesWithAddFields.value.filter(message => message.eventType !== candidateLogType.INTERVIEW_TRANSCRIPTION_READY
          && message.eventType !== candidateLogType.AI_INTERVIEW_REVIEW_READY)
      : messagesWithAddFields.value.filter(message => message.eventType !== candidateLogType.INTERVIEW_TRANSCRIPTION_READY)));


    return {
      filteredMessages,
    };
  },
};
</script>
